import React, { useState, useEffect } from "react";
import { useIntl, FormattedMessage } from 'react-intl'
import {
	Collapse,
	TextField,
	Grid,
	Box,
	MenuItem,
} from '@material-ui/core';
import Switch from "react-switch";

const CentroNotificacionesGridFiltros = (props) => {
	const intl = useIntl();
	// Estado local de edición: los cambios solo se propagan al padre (y disparan
	// el fetch) al hacer click en "Buscar" o Enter en el campo de texto.
	const [filtersState, setFiltersState] = useState(props.filterQuery)

	useEffect(() => {
		setFiltersState(props.filterQuery)
	}, [props.filterQuery])

	const handleBuscar = () => {
		props.handleFilterChange();
		props.setFilterQuery(filtersState);
	};

	const handleOnEnter = (e) => {
		if (e.keyCode === 13) {
			e.preventDefault();
			handleBuscar();
		}
	};

	return (
		<Collapse in={props.dropdownActive}>
			<Grid container item xs={12} spacing={3} style={{ marginBottom: 20 }}>
				<Grid component={Box} item xs={2}>
					<TextField
						select
						label={intl.formatMessage({ id: "centroNotificaciones.filtros.estado_label", defaultMessage: "Estado" })}
						className="col-12"
						value={filtersState.estado}
						onChange={(e) => setFiltersState({ ...filtersState, estado: e.target.value })}
					>
						<MenuItem value="todas">
							<FormattedMessage id="centroNotificaciones.filtros.estado_todas" defaultMessage="Todas" />
						</MenuItem>
						<MenuItem value="no_leida">
							<FormattedMessage id="centroNotificaciones.filtros.estado_no_leida" defaultMessage="No leídas" />
						</MenuItem>
						<MenuItem value="leida">
							<FormattedMessage id="centroNotificaciones.filtros.estado_leida" defaultMessage="Leídas" />
						</MenuItem>
					</TextField>
				</Grid>
				<Grid component={Box} item xs={3}>
					<TextField
						label={intl.formatMessage({ id: "centroNotificaciones.filtros.texto_label", defaultMessage: "Título / Mensaje" })}
						placeholder={intl.formatMessage({ id: "centroNotificaciones.filtros.texto_label", defaultMessage: "Título / Mensaje" })}
						value={filtersState.texto}
						onChange={(e) => setFiltersState({ ...filtersState, texto: e.target.value })}
						onKeyDown={handleOnEnter}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={2}>
					<TextField
						label={intl.formatMessage({ id: "centroNotificaciones.filtros.fecha_desde_label", defaultMessage: "Fecha Desde" })}
						type="date"
						value={filtersState.fechaDesde}
						onChange={(e) => setFiltersState({ ...filtersState, fechaDesde: e.target.value })}
						InputLabelProps={{ shrink: true }}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={2}>
					<TextField
						label={intl.formatMessage({ id: "centroNotificaciones.filtros.fecha_hasta_label", defaultMessage: "Fecha Hasta" })}
						type="date"
						value={filtersState.fechaHasta}
						onChange={(e) => setFiltersState({ ...filtersState, fechaHasta: e.target.value })}
						InputLabelProps={{ shrink: true }}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={2} className="align-self-end">
					<div className="d-flex inline justify-content-around align-items-center">
						<FormattedMessage id="centroNotificaciones.filtros.persistir_filtros" defaultMessage="Persistir Filtros" />
						<Switch
							onChange={(checked) => props.setPersistirFiltros(checked)}
							checked={props.persistirFiltros}
							offColor="#FF4961"
							onColor="#28D094"
						/>
					</div>
				</Grid>
				<Grid component={Box} item xs={1} className="align-self-end">
					<button className="btn btn-primary" onClick={handleBuscar}>
						<i className="fa fa-search fa-xs"></i> <FormattedMessage id="Buscar" defaultMessage="Buscar" />
					</button>
				</Grid>
			</Grid>
		</Collapse>
	)
}

export default CentroNotificacionesGridFiltros
